import React, {useCallback, useState} from 'react';
import styles from './MultiSelect.module.css'
import cx from "classnames";
import Checkbox from "../Checkbox";
import Loader from "../Loader";

export type SelectOption = {
    value: string;
    label: string;
};

type SelectProps = {
    options: SelectOption[];
    onChange: (property: string, value: string, single: SelectOption) => void
    property: string
    selected: string[]
    placeholder: string
    className: string|undefined
    loading?: boolean
};

const MultiSelect: React.FC<SelectProps> = (
    {
        options,
        onChange,
        property,
        placeholder,
        className,
        loading,
        selected
    }) => {
    const [isDropdownOpen, setDropdownOpen] = useState(false);

    const handleCheck = useCallback((option: SelectOption) => {
        const data = (selected.includes(option.value))
            ? selected.filter(s => s !== option.value)
            : [...selected, option.value]

        onChange(property, data.toString(), option)
    }, [selected, onChange, property])

    return (
        <div className={cx(styles['zr-select-wrapper'], className)}>
            <input
                type="text"
                className={cx(styles['zr-search-input'], isDropdownOpen && styles['zr-search-active'])}
                value={selected.length === 0 ? '' : selected.length + ' ausgewählt'}
                placeholder={placeholder}
                disabled={true}
            />
            <button
                className={cx(styles["zr-cover-search"])}
                onClick={() => setDropdownOpen(prev => !prev)}
            />
            <label className={cx(selected.length > 0 && styles['zr-filled'])}>{placeholder}</label>
            <span className={cx(styles['focus-border'])}>
                <i/>
            </span>
            {(isDropdownOpen && options.length > 0)&& (
                <div className={cx(styles['zr-dropdown'])}>
                    {options.map((option) => (
                        <Checkbox
                            key={option.value}
                            label={option.label}
                            property={option.label}
                            value={selected.includes(option.value)}
                            onChange={() => handleCheck(option)}
                            classes={cx(styles['zr-dropdown-item'])}
                        />
                    ))}
                    {loading &&
                        <li
                            key={'loading'}
                            className={cx(styles['zr-dropdown-item'])}
                        >
                            <Loader isLoading={loading}/>
                        </li>
                    }
                </div>
            )}
        </div>
    );
};

export default MultiSelect;
